package com.patronat.top.features.dashboard.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewResponse
import com.patronat.top.features.dashboard.domain.repository.ReviewModerationRepository
import com.patronat.top.features.dashboard.domain.usecase.command.ReplyToOwnerReviewCommand

class ReplyToOwnerReviewUseCase(
    private val repository: ReviewModerationRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ReplyToOwnerReviewCommand, DomainResult<ReviewResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ReplyToOwnerReviewCommand): DomainResult<ReviewResponse> {
        return repository.replyToReview(
            reviewId = command.reviewId,
            text = command.text
        )
    }
}
